module.exports = __webpack_public_path__ + "static/media/md-recording.6623a130.svg";